<div class="n-tela-cadastro">
  <div class="n-container">
    <div class="n-tela-cadastro-content">
      <!-- Coluna esquerda - Informações -->
      <div class="n-tela-cadastro-info">
        <div class="n-header-info">
          <img
            class="n-logo"
            src="assets/icons/nomoh_logo.svg"
            alt="Nomoh Logo"
          />
          <button class="n-welcome-btn" disabled>
            <i class="pi pi-user"></i>
            Editar Perfil
          </button>
        </div>

        <div class="n-title-section">
          <h1 class="n-main-title">
            Atualize suas
            <strong>informações pessoais</strong>
            e mantenha seu perfil sempre atualizado
          </h1>
          <p class="n-main-subtitle">
            Mantenha seus dados sempre atualizados para ter a melhor experiência
            em nossa plataforma.
          </p>
        </div>

        <div class="n-benefits-list">
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>Dados pessoais atualizados</span>
          </div>
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>Informações de contato</span>
          </div>
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>Endereço atualizado</span>
          </div>
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>Foto de perfil personalizada</span>
          </div>
        </div>
      </div>

      <!-- Coluna direita - Formulário -->
      <div class="n-tela-cadastro-form">
        <div class="n-form-card">
          <div class="n-form-header">
            <p class="n-form-subtitle">
              {{ "PAGINA_EDITAR_CONTA.TITULO" | translate }}
            </p>
          </div>

          <form [formGroup]="form" (ngSubmit)="onSubmit()" class="n-form-grid">
            <!-- Upload de Foto de Perfil -->
            <div class="n-form-section">
              <div class="n-upload-container">
                <div class="n-avatar-wrapper">
                  <div class="n-avatar" [class.n-has-image]="filePreviewUrl">
                    <img
                      *ngIf="filePreviewUrl; else avatarPlaceholder"
                      [src]="filePreviewUrl"
                      alt="Preview da foto"
                      class="n-avatar-image"
                    />
                    <ng-template #avatarPlaceholder>
                      <i class="pi pi-user n-avatar-icon"></i>
                    </ng-template>
                  </div>

                  <div class="n-upload-actions">
                    <p-fileUpload
                      #fileUpload
                      name="foto[]"
                      accept="image/*"
                      maxFileSize="10000000"
                      (onSelect)="imagemSelecionada($event, fileUpload)"
                      mode="basic"
                      [auto]="true"
                      chooseIcon="pi pi-camera"
                      chooseLabel=""
                      class="n-upload-btn"
                    ></p-fileUpload>

                    <button
                      *ngIf="filePreviewUrl"
                      type="button"
                      pButton
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-sm p-button-danger n-remove-btn"
                      (click)="removerImagem()"
                    ></button>
                  </div>
                </div>
                <small class="n-upload-hint"
                  >Atualize sua foto de perfil (opcional)</small
                >
              </div>
            </div>

            <!-- Dados Pessoais -->
            <div class="n-form-section">
              <h3 class="n-section-title">
                <i class="pi pi-user"></i>
                {{ "PAGINA_CADASTRO.DADOS_PESSOAIS" | translate }}
              </h3>

              <div class="n-field-group">
                <div class="n-field n-field-full">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.NOME_COMPLETO.ROTULO' | translate }}"
                    controlName="nome"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="nome"
                      placeholder="Digite o nome completo"
                      autocomplete="off"
                      [ngClass]="validarClasseErro('nome')"
                    />
                  </app-form-field>
                </div>

                <div class="n-field n-field-large">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.CPF.ROTULO' | translate }}"
                    controlName="cpfCnpj"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="cpfCnpj"
                      (keydown)="validarMascaraCpfCnpj($event)"
                      placeholder="000.000.000-00"
                      autocomplete="off"
                      [ngClass]="validarClasseErro('cpfCnpj')"
                    />
                  </app-form-field>
                </div>

                <div class="n-field n-field-large">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.TELEFONE.ROTULO' | translate }}"
                    controlName="telefone"
                    [required]="true"
                  >
                    <p-inputMask
                      formControlName="telefone"
                      mask="(99) 99999-9999"
                      placeholder="(00) 00000-0000"
                      autocomplete="off"
                      [ngClass]="validarClasseErro('telefone')"
                    ></p-inputMask>
                  </app-form-field>
                </div>

                <div class="n-field n-field-full">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.EMAIL.ROTULO' | translate }}"
                    controlName="email"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="email"
                      type="email"
                      placeholder="Digite o seu e-mail"
                      autocomplete="off"
                      [ngClass]="validarClasseErro('email')"
                    />
                  </app-form-field>
                </div>

                <div class="n-field n-field-large">
                  <app-form-field
                    label="{{ 'PAGINA_CADASTRO.EDITAR.DADOS_PESSOAIS.REDESOCIAL' | translate }}"
                    controlName="redeSocial"
                  >
                    <input
                      pInputText
                      formControlName="redeSocial"
                      placeholder="@seuusuario"
                      autocomplete="off"
                      [ngClass]="validarClasseErro('redeSocial')"
                    />
                  </app-form-field>
                </div>

                <div class="n-field n-field-large">
                  <app-form-field
                    label="{{ 'PAGINA_CADASTRO.EDITAR.DADOS_PESSOAIS.WEBSITE' | translate }}"
                    controlName="website"
                  >
                    <input
                      pInputText
                      formControlName="website"
                      placeholder="https://seusite.com"
                      type="url"
                      autocomplete="off"
                      [ngClass]="validarClasseErro('website')"
                    />
                  </app-form-field>
                </div>
              </div>
            </div>

            <!-- Endereço -->
            <div class="n-form-section" formArrayName="endereco">
              <h3 class="n-section-title">
                <i class="pi pi-home"></i>
                {{ "PAGINA_CADASTRO.ENDERECO" | translate }}
              </h3>

              <!-- Linha 1: CEP + Logradouro -->
              <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
                <div class="w-full md:w-4 n-cep-section">
                  <div class="n-field">
                    <app-form-field
                      label="{{ 'CAMPO_ENTRADA.CEP.ROTULO' | translate }}"
                      controlName="codPostal"
                      [required]="true"
                      helpText="Preenchimento automático"
                    >
                      <p-inputMask
                        formControlName="codPostal"
                        mask="99999-999"
                        placeholder="00000-000"
                        (onBlur)="buscarCep()"
                        autocomplete="off"
                        [ngClass]="validarClasseErro('codPostal')"
                      ></p-inputMask>
                    </app-form-field>
                  </div>
                </div>
                <div class="w-full md:w-8 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.LOGRADOURO.ROTULO' | translate }}"
                    controlName="logradouro"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="logradouro"
                      placeholder="Digite o logradouro"
                      autocomplete="off"
                      [ngClass]="validarClasseErro('rua')"
                    />
                  </app-form-field>
                </div>
              </div>

              <!-- Linha 2: Número + Complemento -->
              <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
                <div class="w-full md:w-3 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.NUMERO.ROTULO' | translate }}"
                    controlName="numero"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="numero"
                      placeholder="123"
                      autocomplete="off"
                      [ngClass]="validarClasseErro('numero')"
                    />
                  </app-form-field>
                </div>

                <div class="w-full md:w-9 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.COMPLEMENTO.ROTULO' | translate }}"
                    controlName="complemento"
                  >
                    <input
                      pInputText
                      formControlName="complemento"
                      placeholder="Complemento (Opcional)"
                      autocomplete="off"
                    />
                  </app-form-field>
                </div>
              </div>

              <!-- Linha 3: Bairro + Cidade -->
              <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
                <div class="w-full md:w-6 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.BAIRRO.ROTULO' | translate }}"
                    controlName="bairro"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="bairro"
                      placeholder="Digite o bairro"
                      autocomplete="off"
                      [ngClass]="validarClasseErro('bairro')"
                    />
                  </app-form-field>
                </div>

                <div class="w-full md:w-6 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.CIDADE.ROTULO' | translate }}"
                    controlName="cidade"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="cidade"
                      placeholder="Digite a cidade"
                      autocomplete="off"
                      [ngClass]="validarClasseErro('cidade')"
                    />
                  </app-form-field>
                </div>
              </div>

              <!-- Linha 4: Estado + País -->
              <div class="flex flex-column md:flex-row w-full gap-3">
                <div class="w-full md:w-6 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.ESTADO.ROTULO' | translate }}"
                    controlName="estado"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="estado"
                      placeholder="Digite o estado"
                      autocomplete="off"
                      [ngClass]="validarClasseErro('estado')"
                    />
                  </app-form-field>
                </div>

                <div class="w-full md:w-6 n-field">
                  <app-form-field
                    label="{{ 'CAMPO_ENTRADA.PAIS.ROTULO' | translate }}"
                    controlName="pais"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="pais"
                      placeholder="Digite o país"
                      autocomplete="off"
                      [ngClass]="validarClasseErro('pais')"
                    />
                  </app-form-field>
                </div>
              </div>
            </div>

            <!-- Botões de Ação -->
            <div class="n-form-actions">
              <p-button
                label="{{ 'BOTAO.VOLTAR' | translate }}"
                (onClick)="cancelar()"
                [disabled]="botaoLoading()"
                severity="secondary"
                styleClass="n-button-sec"
                type="button"
              ></p-button>

              <p-button
                label="{{ 'PAGINA_EDITAR_CONTA.BOTAO_SALVAR' | translate }}"
                [loading]="botaoLoading()"
                styleClass="n-button-prim"
                type="submit"
              ></p-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Dialog de Confirmação -->
<p-confirmDialog #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="n-confirm-dialog">
      <div class="n-confirm-icon">
        <i class="pi pi-user"></i>
      </div>
      <h3 class="n-confirm-title">{{ message.header }}</h3>
      <p class="n-confirm-message">{{ message.message }}</p>
      <div class="n-confirm-actions">
        <p-button
          label="OK"
          (onClick)="cd.accept()"
          styleClass="n-button-prim"
        ></p-button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>